// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ticket-controls__buttons {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px;\n&__footer{\n        flex: 1 0 100%;\n        max-width: 100%;\n}\n@media ( max-width: 767px) {\n.btn{\n            width: 100%;\n}\n}\n}\n[dir] .ticket-controls__buttons {\n    margin-top: 20px\n}\n[dir] .order-print__footer {\n    margin-top: 10px;\n}\n\n", ""]);
// Exports
module.exports = exports;
